export const getInitials = (name, lastName) => {
    const first = name ? name.trim() : '';
    const last = lastName ? lastName.trim() : '';
    return `${first.charAt(0)}${last.charAt(0)}`;
};
